<h2 mat-dialog-title>{{'dialogs.agentLeadOfferAccepted.title' | translate}}: {{lead.id}}
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div mat-dialog-content>
  <p>{{'agent.offer.accepted' | translate}}</p>
  <p><span style="font-weight: bold;">&#10100;&#10100;{{'dialogs.agent.businessName' | translate}}&#10101;&#10101;</span>
    ({{lead.fiscalIds[0].value}}), in provincia di <span style="font-weight: bold;">{{lead.province?.name}}</span></p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="onShowInfoClicked()">
    <mat-icon>visibility</mat-icon> {{'dialogs.agentLeadOfferAccepted.infoButtonText' | translate}}
  </button>
</div>
